import { render, staticRenderFns } from "./PromoteButton.vue?vue&type=template&id=d66625c8&"
import script from "./PromoteButton.vue?vue&type=script&lang=js&"
export * from "./PromoteButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports